module.exports = __webpack_public_path__ + "6794e7b0de33e76f4fe14d15c24e6325.png";